<template>
  <div class="acupuncture-auricular">
		<v-row no-gutters align="center" class="mb-5">
			<v-btn
				color="primary"
				fab
				x-small
				@click="newTreatment = !newTreatment"
			>
				<v-icon>add</v-icon>
			</v-btn>
			<v-btn :color="appointment.auricular_notes ? 'green' : 'primary'" fab x-small class="ml-2" @click="showNotes = true">
				<v-icon small>mdi-note-outline</v-icon>
				<v-dialog v-model="showNotes" max-width="65%">
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary">
							<translate>Auricular Acupuncture</translate>
							<span class="mx-2">-</span>
							<translate>Notes</translate>
						</v-card-title>
						<v-card-text>
							<v-row no-gutters class="mt-3">
								<v-col cols="12" sm="12">
									<v-textarea
										@blur="$emit('save-notes', true)"
										:label="$gettext('Notes')"
										filled
										hide-details
										v-model="appointment.auricular_notes"
										auto-grow
									></v-textarea>
								</v-col>
							</v-row>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click="showNotes = false">
								<translate>Close</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-btn>
			<v-btn color="primary" fab x-small class="ml-2" @click="graphicMode = true">
				<v-icon>mdi-ear-hearing</v-icon>
			</v-btn>
			<AcupunctureGraphicMode :show="graphicMode" @close="graphicMode = false" :auricular="true" :createMode="true" :inAppointment="true" />
		</v-row>
		<v-row v-if="newTreatment" no-gutters class="mb-5 px-3">
			<v-col cols="12">
				<SearchPoints @add-point="addPoint" :auricular="true" />
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12">
				<p v-if="acuPoints.length == 0" class="font-weight-thin ml-2" v-translate>No prescription.</p>
				<AcupunctureGrid v-else :acuPoints="acuPoints" @remove-point="removePoint" :auricular="true" />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import AcupunctureGraphicMode from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGraphicMode.vue";
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";
import AcupunctureGrid from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGrid.vue";

export default {
	name: "AcupunctureAuricular",
	props: {
		appointment: {}
	},
  components: {
    AcupunctureGraphicMode,
		SearchPoints,
		AcupunctureGrid
  },
  data: () => ({
    valid: false,
		newTreatment: false,
		showNotes: false,
		showRecommendations: false,
		graphicMode: false
  }),
  computed: {
    acuPoints() {
			return this.$store.getters.acuPoints(true);
    },
    saving() {
			return this.$store.getters.acuLoading;
    }
  },
  methods: {
    addPoint(point) {
			let data = {
				appointment: this.$route.params.aid,
				op: "add_points",
				ids: [point.id],
				technics: [1]
			}
			this.$store.dispatch("ADD_POINTS", data);
		},
    removePoint(point) {
			let data = {
				appointment: this.$route.params.aid,
				op: "remove_point",
				id: point.id
			}
			this.$store.dispatch("REMOVE_POINT", data);
		}
  }
}
</script>